import { Fragment, useEffect, useState } from "react";
import WebDesigner from "../WebDesigner";
import { LeftCaret } from "./ComponentContextMenu";
import { EditorState, PannelMenuType } from "../EditorTypes";
import ConnectDomainClickAd from "../Adds/ConnectDomainClickAd";
import store from "app/store";
import { StyleBuilderState } from "../Stylebuilder";
import { MultiLocationLive } from "components/Multilocation/MulitLocationLIve";
import { LoginUserType } from "utils/Utils";
import { BlogBrowserWrapper } from "./BlogBrowser";



export enum SettingsMenuOptionType{

    OpenLeftPanel,
    OpenRightPanel,
    OpenSubMenu,
}

export enum SettingsSubMenu{
    None,
    SiteStyling,
    AnnouncementTools
}




export default function SettingsMenuRedo({designer,startInStyle}:{designer:WebDesigner,startInStyle?:boolean}) {
    const { IsPurchasedDomain,IsMutipleLocation } = store.getState().Business;
    let {reactBusinessId } = designer.props;

    const mainMenuItems = [
        {
            label:"Site Styling",
            labelOverride:<div className="flex-row gap-med"><StylingIcon/> Site Styling </div>,
            onSelect:()=>{
            setSubMenu(SettingsSubMenu.SiteStyling);
            setSelectedMenuItem("Fonts");
            openRightPanel(1);

        },ShowAdmin:true},
        {
            label:"General",
            labelOverride:<div className="flex-row gap-med"><GeneralIcon/> General</div>,
            onSelect:()=>{openLeftPanel(PannelMenuType.GeneralSettings)},ShowAdmin:false},
        {
            label:"Domains",
            labelOverride:<div className="flex-row gap-med"><DomainIcon/> Domains</div>,

            onSelect:()=>{openLeftPanel(PannelMenuType.Domains)},ShowAdmin:false},
            {label:"divider",onSelect:()=>{}},
        {label:"Change Theme",onSelect:()=>{

            let windowLocationnew = window.location.href;
            let folder = windowLocationnew.indexOf("admin/") > 0 ? "admin" : "business";
            let styleid =  designer.props.styleId;
            let layoutid =  designer.props.layoutId;


            window.open('/' + folder + '/' + styleid + "/" + layoutid + "/changestyle","_self");

        }},

        {label:"Change Layout",onSelect:()=>{

            let windowLocationnew = window.location.href;
            let folder = windowLocationnew.indexOf("admin/") > 0 ? "admin" : "business";
            let styleid =  designer.props.styleId;
            let layoutid =  designer.props.layoutId;


            window.open('/' + folder + '/' + styleid + "/" + layoutid + "/changelayout","_self");

        }},
        {label:"Editor Preferences",onSelect:()=>{openLeftPanel(PannelMenuType.EditorSettings)},ShowAdmin:true},

        {label:"Announcement Tools",onSelect:()=>{
            setSubMenu(SettingsSubMenu.AnnouncementTools);
            setSelectedMenuItem("Announcement Bar");
            openRightPanel(StyleBuilderState.AnnouncementBar);

        }},


        {label:"Version History",onSelect:()=>{
            designer.openToPannelMenu(PannelMenuType.None);
            setSelectedMenuItem("");
            designer.deselectAll();
            designer.openToVersionHistory();
        },ShowAdmin:false},
        {label:"Cookie Banner",onSelect:()=>{openRightPanel(10); openLeftPanel(PannelMenuType.None); setTimeout(()=>{designer.deselectAll()})},ShowAdmin:false},

        {label:"Blogging",onSelect:()=>{
            designer.setState({styleMenuState:StyleBuilderState.SelectedComponent});
            openLeftPanel(PannelMenuType.None);

        },ShowAdmin:false},

    ]

    if(MultiLocationLive||designer.props.siteData.userContext.userType == LoginUserType.VagaroAdmin){
        mainMenuItems.splice(mainMenuItems.length-2,0,
        {label:"Multi-Location",onSelect:()=>{openLeftPanel(PannelMenuType.Multilocation)},ShowAdmin:false}
        )
    }




    const siteStylingMenu = [

      {label:"Fonts",onSelect:()=>{openRightPanel(1)},ShowAdmin:true},
      {label:"Colors",onSelect:()=>{openRightPanel(2)},ShowAdmin:true},
      {label:"Headings",onSelect:()=>{openRightPanel(3)},ShowAdmin:true},
      {label:"Paragraphs",onSelect:()=>{openRightPanel(4)},ShowAdmin:true},
      {label:"Buttons",onSelect:()=>{openRightPanel(5)},ShowAdmin:true},
      {label:"Links",onSelect:()=>{openRightPanel(6)},ShowAdmin:true},
      {label:"Page Spacing",onSelect:()=>{openRightPanel(7)},ShowAdmin:true},
      {label:"Text Scaling",onSelect:()=>{openRightPanel(StyleBuilderState.FontScaling)},ShowAdmin:true},
      {label:"Image Mapping",onSelect:()=>{openRightPanel(8)},ShowAdmin:true},
    ]

    const AnnouncementToolsMenu = [

            {label:"Announcement Bar",onSelect:()=>{openRightPanel(StyleBuilderState.AnnouncementBar)},ShowAdmin:true},
            // {label:"Cookie Banner",onSelect:()=>{openRightPanel(StyleBuilderState.CookieBanner)},ShowAdmin:true},
            {label:"Pop-up",onSelect:()=>{openRightPanel(StyleBuilderState.Popup)},ShowAdmin:true},
    ]

    if(!designer.props.siteData.userContext.isAdmin)//remove image mapping for non admin users
     siteStylingMenu.pop();



    const startMenu = startInStyle?SettingsSubMenu.SiteStyling:SettingsSubMenu.None;
    const startSelection = startInStyle?"Fonts":"";
    const [selectedMenuItem,setSelectedMenuItem] = useState<string>(startSelection);
    const [subMenu,setSubMenu] = useState<SettingsSubMenu>(startMenu);


    let currentMenu: {labelOverride?:any, label:string,onSelect:()=>void,ShowAdmin?:boolean}[] = mainMenuItems;
    let currentTitle = "Settings";
    if(subMenu == SettingsSubMenu.SiteStyling){
        currentMenu = siteStylingMenu;
        currentTitle = "Site Styling";
    }
    else if(subMenu == SettingsSubMenu.AnnouncementTools){
        currentTitle = "Announcement Tools";
        currentMenu = AnnouncementToolsMenu;
    }


    designer.onDeselectMenu = ()=>{


        setSelectedMenuItem("");

    }

    designer.openToAnnouncementBar = ()=>{
        openRightPanel(9);
        setSelectedMenuItem("Announcement Bar");
        setSubMenu(SettingsSubMenu.None);
        setTimeout(()=>{designer.deselectAll()})
    }

    designer.openToMultiLocationSettings = ()=>{

        designer.openSettingsMenu();


        openLeftPanel(PannelMenuType.Multilocation);
        setSubMenu(SettingsSubMenu.None);
        setSelectedMenuItem("Multi-Location");

    }

    designer.openToDomainSettings = ()=>{


        designer.openSettingsMenu();


        openLeftPanel(PannelMenuType.Domains);
        setSubMenu(SettingsSubMenu.None);
        setSelectedMenuItem("Domains");



    }

    designer.openToBlogSettings = ()=>{
        designer.openSettingsMenu();

        setSubMenu(SettingsSubMenu.None);
        setSelectedMenuItem("Blogging");
    }

    (window as any).OpenToBlogSettings = designer.openToBlogSettings;


    const selectOption = (item:{label:string,onSelect?:Function})=>{

        const execute = ()=>{
            setSelectedMenuItem(item.label);
            if(item.onSelect)
                item.onSelect();
        }

        if(designer.panelMenuLocked)
            designer.promptForPanelExit(execute);
        else
            execute();
    }

    const openRightPanel = (state:number)=>{


        if(designer.state.editSate===EditorState.InPannelMenu)
            designer.switchToEditorState(EditorState.Normal)

        designer.openToPannelMenu(PannelMenuType.None);

        designer.switchToMenuState(state);
        designer.setState({rightPannelExpanded:true});
    }

    const openLeftPanel = (state:PannelMenuType)=>{
        designer.openToPannelMenu(state);

    }


    useEffect(()=>{

        if(startInStyle){
            openRightPanel(1);
        }
//eslint-disable-next-line
    },[])



    return (

        <>
{
    selectedMenuItem == "Blogging" && <BlogBrowserWrapper
    onOpenPost={(post:string)=>{
        designer.trySwitchPage(post,()=>{},true);
        setSelectedMenuItem("");
    }}
    currentPost={designer.state.currentPageId}
    onCreatePost={()=>{

    }}

    onClose={()=>setSelectedMenuItem("")}  context={designer.props.siteData.userContext} />
}

    {subMenu == SettingsSubMenu.None?
         <h2 className="tab-title panel-heading">{currentTitle}</h2>:
         <h2 className="panel-heading" style={{cursor:"pointer"}} onClick={()=>{setSubMenu(SettingsSubMenu.None);  openRightPanel(StyleBuilderState.SelectedComponent);

            setTimeout(()=>designer.autoToggleRightPanel(false),0); }}><LeftCaret/>{currentTitle}</h2>
    }
    {
        subMenu == SettingsSubMenu.None&&          <ConnectDomainClickAd DomainNotPurcheshed={IsPurchasedDomain === false} designer={designer}/>
    }
        <div className="tab-links relative bottom-white-fade" style={{background:"white",zIndex:1}}>{
            currentMenu.map((item,index)=>{

                if(item.label == "divider"){
                    return <hr key={index} style={{margin:"8px 16px"}} />
                }

                if (reactBusinessId > 0 || item.ShowAdmin === true) {

                    let lbl = item.labelOverride ? item.labelOverride : item.label;

                    return(
                        item.label != "Multi-Location" ?
                        <button key={item.label + index}className={ "invisible-button tab-link "+(item.label===selectedMenuItem?"active":"")} onClick={()=>{ selectOption(item)}}>
                         {lbl}

                         </button>
                         : (IsMutipleLocation && <Fragment key={index}> <button key={item.label}className={ "invisible-button tab-link "+(item.label===selectedMenuItem?"active":"")} onClick={()=>{ selectOption(item)}}>
                                                    {item.label}</button>  </Fragment>
                    )
                    )
                }
                else {
                    return null;
                }
            })
        }</div>
        </>



    )














}


function DomainIcon(){
    return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 496 512"><path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z"/></svg>
}

function GeneralIcon(){
    return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 512 512"><path d="M224 96.1v48.8l29.7 29.7c-6.8-34.8 3.5-70.3 28.5-95.3 20.3-20.3 47.2-31.2 75-31.2h1.2L301 105.3l15.1 90.6 90.6 15.1 57.3-57.3c.3 28.3-10.6 55.5-31.2 76.1-9.3 9.3-20.2 16.4-31.8 21.6 1.8 1.6 3.9 2.9 5.6 4.6l30.7 30.7c10.5-6.3 20.5-13.9 29.4-22.9 38.1-38.1 53.7-94.3 40.7-146.6C504.4 105 495 95.4 483 92c-12.2-3.4-25.2 .1-34 9l-58.7 58.6-32.4-5.4-5.4-32.4 58.6-58.6c8.9-8.9 12.3-21.9 8.9-34-3.3-12.1-13-21.5-25.2-24.5-53.2-13.2-107.9 2-146.6 40.6C238 55.5 229.7 67 222.9 79.2l1.1 .8v16.1zM106 454c-12.8 12.8-35.3 12.8-48.1 0-6.4-6.4-10-15-10-24 0-9.1 3.5-17.6 10-24l134.4-134.4-33.9-33.9L24 372C8.5 387.5 0 408.1 0 430s8.5 42.5 24 58 36.1 24 58 24 42.5-8.5 58-24l100.9-100.9c-9.7-15.8-15.2-33.8-15.7-52.1L106 454zm395.1-58.3L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7z"/></svg>
}

function StylingIcon(){
    return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 512 512"><path d="M128 224c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.4-32-32-32zM418.6 58.1C359.2 9.3 281.3-10 204.6 5 104.9 24.4 24.7 104.2 5.1 203.7c-16.7 84.2 8.1 168.3 67.8 230.6 47.3 49.4 109.7 77.8 167.9 77.8 8.8 0 17.5-.6 26.1-2 24.2-3.7 44.6-18.7 56.1-41.1 12.3-24 12.3-52.7 .2-76.6-6.1-12-5.5-26.2 1.8-38 7-11.8 18.7-18.4 32-18.4h72.2c46.4 0 82.8-35.7 82.8-81.3-.2-76.4-34.3-148.1-93.4-196.6zM429.2 288H357c-29.9 0-57.2 15.4-73 41.3-16 26.1-17.3 57.8-3.6 84.9 5.1 10.1 5.1 22.7-.2 32.9-2.6 5-8.7 13.7-20.6 15.6-49.3 7.7-108.9-16.6-152-61.6-48.8-50.9-69-119.4-55.4-188 15.9-80.6 80.8-145.3 161.6-161 62.6-12.3 126.1 3.5 174.3 43.1 48.1 39.5 75.7 97.6 75.9 159.6 0 18.6-15.3 33.2-34.8 33.2zM160 128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.4-32-32-32zm96-32.1c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32c0-17.6-14.3-32-32-32zm96 32.1c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"/></svg>
}